import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-physical-description-list',
  templateUrl: './physical-description-list.component.html',
  styleUrls: ['./physical-description-list.component.css']
})
export class PhysicalDescriptionListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
